import EditCommunitiesModal from './EditCommunitiesModal';

export default EditCommunitiesModal;
